/**
 * 树结构对应不同的数据处理配置
 */
export const TREE_CONFIG = {
  deptIdList: {
    key: "id",
    title: "name",
    parentId: "parentId",
    id: "id",
  },
  parentId: {
    key: "id",
    title: "name",
    parentId: "parentId",
    id: "id",
  },
  templateCode: {
    key: "code",
    id: "code",
    parentId: "parentCode",
  },
};
